import React, { useRef, useEffect, useCallback, useMemo, useState } from 'react'

import * as d3 from 'd3'

import R from 'ramda'
import numeral from 'numeral'
import { Tabs } from 'antd'

const CauseCodeBarGraphByFieldName = props => {
  const margin = 30
  const {
    actualHeight = 470,
    actualWidth = 300,
    causeCodeData = [],
    fieldName = 'lostOppMargin',
    showDoller = true,
  } = props

  const totalValue = R.compose(
    R.reduce((a, b) => a + b, 0),
    R.filter(d => d > 0),
    R.map(d => parseInt(d)),
    R.map(d => d[fieldName])
  )(causeCodeData)

  const getPerc = value => {
    // console.log({ value, totalValue, pc: value / totalValue })
    if (parseInt(value) <= 0) return 0
    return ((parseInt(value) / totalValue) * 100).toFixed(2)
  }

  const height = actualHeight - 100 - margin
  const width = actualWidth - margin

  const data = causeCodeData.map(d => ({ ...d, pct: getPerc(d[fieldName]) }))

  const xScale = useMemo(
    _ =>
      d3
        .scaleBand()
        // .range([margin, width])
        .range([margin, width - margin])
        .domain(data.map(d => d.causeDescrip))
        .paddingInner(0)
        .padding(0),
    [data, width]
  )

  const yScale = useMemo(
    _ =>
      d3
        .scaleLinear()
        .range([height, 0])
        // .domain([margin, d3.max(graphData, (d) => d.caPercent)]);
        .domain([0, 100]),
    // .tickFormat(d => d + ' %')
    [height]
  )

  const svgRef = useRef()

  const drowBarChart = useCallback(
    _ => {
      const svg = d3.select(svgRef.current)
      if (svgRef.current) {
        // const selection = d3.selectAll("rect").data(graphData);
        // const g = d3.select("#dg");
        d3.selectAll('#xid' + fieldName).remove()
        d3.selectAll('#yid' + fieldName).remove()
        // d3.selectAll('#rid').remove()
        svg
          .append('g')
          .attr('id', 'xid' + fieldName)
          .attr('transform', 'translate(' + 0 + ',' + (height + margin) + ')')
          .call(d3.axisBottom(xScale))
          .selectAll('text')
          .attr('y', 0)
          .attr('x', 9)
          .attr('dy', '.35em')
          .attr('transform', 'rotate(45)')
          .attr('text-orientation', 'upright')
          .style('text-anchor', 'start')

        svg
          .append('g')
          .attr('id', 'yid' + fieldName)
          .attr('transform', 'translate(' + margin + ',' + margin + ')')
          .call(
            d3
              .axisLeft(yScale)
              .tickValues([0, 20, 40, 60, 80, 100])
              .tickFormat(d => d + '%')
              // .tickSizeInner(150)
              .tickSize(1)
          )
      }
    },
    [height, xScale, yScale, fieldName]
  )

  useEffect(_ => drowBarChart(), [drowBarChart, data])

  return (
    <div
      style={{
        height: actualHeight + 'px',
        width: actualWidth + 'px',
        border: '1px solid black',
      }}
    >
      <svg
        key={fieldName}
        ref={svgRef}
        style={{
          height: actualHeight + 'px',
          width: actualWidth + 'px',
          margin: '10px',
        }}
      >
        <g id="dg" transform={'translate(' + margin + ',' + margin + ')'}>
          {data.map(d => (
            <g key={d.causeDescrip} id="rid">
              <rect
                key={d.causeDescrip}
                height={height - yScale(d.pct)}
                width={xScale.bandwidth() / 2}
                // bandwidth={xScale.bandwidth() - 3}
                x={xScale(d.causeDescrip)}
                y={yScale(d.pct)}
                fill="#babad6"
                style={{ padding: '1px' }}
              >
                <title>
                  <div
                    style={{
                      border: '1px solid black',
                      backgroundColor: 'yello',
                    }}
                  >
                    {d.causeDescrip} - {showDoller ? '$' : ''}
                    {''}
                    {numeral(d[fieldName]).format('000,000.00')} - ({d.pct}%)
                  </div>
                </title>
              </rect>
            </g>
          ))}
        </g>
      </svg>
    </div>
  )
}

export { CauseCodeBarGraphByFieldName }

const CauseCodeBarGraph = props => {
  const [activateKey, setActivateKey] = useState('Lost Margin')
  return (
    <div>
      <Tabs
        defaultActiveKey="Lost Margin"
        type="card"
        onChange={setActivateKey}
        activeKey={activateKey}
        height={props.height}
      >
        <Tabs.TabPane tab="Lost Margin" key="Lost Margin" label="Lost Margin">
          <div>
            <CauseCodeBarGraphByFieldName {...props} />
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane
          key="Lost Revenue"
          tab="Lost Revenue"
          label="Lost Revenue"
        >
          <CauseCodeBarGraphByFieldName {...props} fieldName="lostOppRevenue" />
        </Tabs.TabPane>
        <Tabs.TabPane key="Lost MWH" tab="Lost MWH" label="Lost MWH">
          <CauseCodeBarGraphByFieldName
            {...props}
            fieldName="lostOppMwh"
            showDoller={false}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
}

export default CauseCodeBarGraph
